module.exports = __webpack_public_path__ + "static/media/Logout.cd5b7b9f.svg";